export class AdutPermium {
    constructor(public data: {
        StartTime?: String,
        EndTime?: String,
        Duration?: Number,
        Age?: Number,
        Gender?: String,
        HazardLevel?: Number,
        PaymentFrequency?: Number,
        DeathByAccident?: Number,
        InvalidityByAccident?: Number,
        Surgery?: Number,
        MonthlyRent?: Number,
        DailyFee?: Number,
        TreatmanExpenses?: Number,
        IncludeMSO?: Boolean,
        IncludeDNA?: Boolean,
        AdditionalInsurance?: Boolean,
        SelectedPackage?: Number,
        SumInsured?: Number,
        PaymentPeriod?: Number,
        RentPaymentFrequency?: Number
    }) { }
}